import { ForwardRefExoticComponent } from "react";
import {
    ChatIcon,
    CommentIcon,
    GroupedBarChartIcon,
    LogOutIcon,
    NewGridItemIcon,
    PersonIcon,
    ShopIcon,
    FlowBranchIcon,
    CreditCardIcon
} from "evergreen-ui";

export type NavigationTab = {
    name: string,
    to?: string,
    icon: ForwardRefExoticComponent<any>,
    showNewBadge?: boolean,
};

export const tabs: {top: NavigationTab[], bottom: NavigationTab[]} = {
    top: [
        {
            name: "Products",
            to: "/products",
            icon: NewGridItemIcon,
        },
        {
            name: "Messages",
            to: "/messages",
            icon: ChatIcon,
        },
        {
            name: "Analytics",
            to: "/analytics",
            icon: GroupedBarChartIcon,
        },
        {
            name: "Payouts",
            to: "/payouts",
            icon: CreditCardIcon,
        },
        {
            name: "Stores",
            to: "/stores",
            icon: ShopIcon,
        },
        {
            name: "Modifiers",
            to: "/cost-payout-modifiers",
            icon: FlowBranchIcon,
        },
        {
            name: "Chat",
            to: "/chat",
            icon: CommentIcon,
        }
    ],
    bottom: [
        {
            name: "Settings",
            to: "/settings",
            icon: PersonIcon,
        },
        {
            name: "Logout",
            to: "/logout",
            icon: LogOutIcon,
        }
    ],
};
